import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GalleryDto, GalleryTheme, Section } from '@nusign/picflow-backend-types';
import { ColorSelectorComponent } from '../../../color-selector/color-selector.component';
import { SwitchComponent } from '../../../components/switch/switch.component';
import { debounce } from '../../../lib/debounce';
import { sectionVerticalPadding, sectionWidths } from '../../../lib/default-asset-section';
import { SectionService } from '../../../services/section.service';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { ClickTrackDirective } from '../../../shared/directives/click-track.directive';

@Component({
  selector: 'app-common-section-settings',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './common-section-settings.component.html',
  styleUrl: './common-section-settings.component.scss',
  imports: [ButtonDirective, FormsModule, ColorSelectorComponent, ClickTrackDirective, SwitchComponent],
})
export class CommonSectionSettingsComponent {
  private sectionService = inject(SectionService);
  widths = [
    { value: sectionWidths.small, label: 'S' },
    { value: sectionWidths.medium, label: 'M' },
    { value: sectionWidths.full, label: 'L' },
  ];
  verticalPaddings = [
    { value: sectionVerticalPadding.small, label: 'S' },
    { value: sectionVerticalPadding.medium, label: 'M' },
    { value: sectionVerticalPadding.large, label: 'L' },
  ];
  @Input({ required: true }) section: Section;
  @Input({ required: true }) gallery: GalleryDto;
  @Input({ required: true }) theme: GalleryTheme;
  @Output() onUpdateLayout = new EventEmitter();

  colorMenuOpen = signal(false);

  updateWidth() {
    this.onUpdateLayout.emit();
    this.sectionService.updateSection(this.section, { width: this.section.width }).subscribe();
  }

  updateVerticalPadding() {
    this.onUpdateLayout.emit();
    this.sectionService.updateSection(this.section, { vertical_padding: this.section.vertical_padding }).subscribe();
  }

  updateLayoutBackgroundColor(color: string) {
    this.sectionService.optimisticUpdateSection(this.section, {
      layout_background_color: color || null,
    });
    this.onUpdateLayout.emit();
    this.saveLayoutBackgroundColor();
  }

  saveLayoutBackgroundColor = debounce(() => {
    this.sectionService
      .updateSection(this.section, { layout_background_color: this.section.layout_background_color || null })
      .subscribe();
  }, 500);

  updateSectionHasTitle(addTitle: boolean) {
    if (addTitle) {
      this.sectionService.updateSection(this.section, { text_title: '__EMPTY_TITLE__' }).subscribe();
    } else {
      this.sectionService.updateSection(this.section, { text_title: null, text_paragraph: null }).subscribe();
    }
  }

  colorClick(event: Event) {
    this.colorMenuOpen.set(true);
    event.stopPropagation();
  }
}
